/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { InviteService } from 'lib';
import { IInvite, IInviteVerify } from 'types';
import { Invites } from './types';

const initialState: IInvite | null = null;

export const invitesReducer: Reducer<IInvite | null> = (state = initialState, action) => {
  switch (action.type) {
    case Invites.VERIFY_INVITE_SUCCESS: {
      const { id } = action.payload as IInviteVerify;
      if (InviteService.getInviteToken() !== id) InviteService.setInviteToken(id);

      return {
        ...state,
        ...action.payload,
      };
    }
    case Invites.GET_INVITE_SUCCESS:
    case Invites.ACCEPT_INVITE_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case Invites.CLEAR_INVITE: {
      InviteService.clearInviteToken(); // clear invite-token from sessionStorage
      return null;
    }
    default: {
      return state;
    }
  }
};
